import { render, staticRenderFns } from "./ReporteCapacitacionGrupal.vue?vue&type=template&id=0076ea08"
import script from "./ReporteCapacitacionGrupal.vue?vue&type=script&lang=js"
export * from "./ReporteCapacitacionGrupal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports